import { PROMOTION_TYPES } from '@/domainLogic/index.ts';
import type { FARE_TYPE } from '@/app/common/starTrack/events/utils/resultClickedUtils.ts';
import { FARE_TYPE_STANDARD } from '@/app/common/starTrack/events/utils/resultClickedUtils.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import type { PartialStay } from '@/app/common/starTrack/events/utils/starTrack.types.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

export enum LOYALTY_CONTEXT {
  RESULT = 'RESULT',
  DETAIL = 'DETAIL',
}

export enum LOYALTY_BANNER_TYPE {
  NOT_LOGGED = 'NOT_LOGGED',
  LOGGED_NO_LOYALTY = 'LOGGED_NO_LOYALTY',
  LOGGED_WITH_LOYALTY = 'LOGGED_WITH_LOYALTY',
}

export const LOYALTY_LABEL = 'Loyalty';

export enum LOYALTY_CONTENT {
  SIGNUP = 'signup',
  DISCOUNT = 'discount',
}

// “top”, “middle” or “bottom” (if only 1 component on the page then top)
export enum LOYALTY_POSITION {
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom',
}

export const createTotalPriceFareType = (isLoyalty: boolean, promotionType: PROMOTION_TYPES | null): FARE_TYPE =>
  isLoyalty ? PROMOTION_TYPES.LOYALTY : promotionType || FARE_TYPE_STANDARD.STD;

export const createPartialStay = (searchParams: SearchParams): PartialStay => {
  const partialStayParam = searchParams[URLParameters.CUSTOM_CHECKIN_CHECKOUT];
  const flag = partialStayParam?.indexOf(',') >= 0;
  return {
    flag,
    dateFrom: flag ? partialStayParam.split(',')[0] : null,
    dateTo: flag ? partialStayParam.split(',')[1] : null,
  };
};
